export default __webpack_public_path__ + "static/wordpress-d8c21e2e96650d252fcd045fa6a373bb.png";